import { TwinDictionary } from './dictionary'

export const parseShippingServices = (arrShippingServices: any) => {
    const result: TwinDictionary = {}
    if (arrShippingServices) {
        for (const shippingService of arrShippingServices) {
            result[shippingService.id] = shippingService.ShippingCompany.name + ' - ' + shippingService.name
        }
    }
    return result
}

export const parseShippingServicesToDict = (arrShippingServices: any) => {
    const result: TwinDictionary = {}
    if (arrShippingServices) {
        for (const element of arrShippingServices) {
            result[element.id] = { name: element.ShippingCompany.name + ' - ' + element.name, fullname_short: element.name, id: element.id}
        }
    }
    return result
}